export const env = process.env.NODE_ENV.trim();
export const isDevelopment = env === 'development';
export const isStaging = env === 'staging';
export const isProduction = env === 'production';
export const backEndAPIUrl = process.env.REACT_APP_BACK_END_API_URL;
export const localStorageKey = 'BMWWebshop';
export const checkTimerInterval = 5000;
export const websocketURL = process.env.REACT_APP_WEBSOCKET_URL;
export const initialCartLoadSeriesPageSize = 2;
export const modelDescriptionLimit = 24;
export const modelLockRemainingTimeThreshold = 20000;
export const miniDisclaimer = 'European Model Shown';
export const helpPageLink = process.env.REACT_APP_HELP_PAGE_LINK_URL;
export const maximumVisibleTemplates = 19;
export const AUTH_URL = "https://auth-i.bmwgroup.com:443/auth/oauth2/realms/root/realms/internetb2x/authorize";
export const TOKEN_ENDPOINT = "https://auth-i.bmwgroup.com:443/auth/oauth2/realms/root/realms/internetb2x/access_token";
export const USERINFO_ENDPOINT = "https://auth-i.bmwgroup.com:443/auth/oauth2/realms/root/realms/internetb2x/userinfo";
export const CLIENT_ID = "841d42d5-7901-4068-a390-38cca24931bd";
export const REDIRECT_URI = "https://bts-webshop-int.aws.bmw.cloud/oauth2/idpresponse";
export const CLIENT_SECRET = "T8hoNIxHmtKag2P9qxGOBKtCGZEsK2Mb27OeTP8v"; // ⚠️ Only use if backend is involved
export const SCOPE = "openid profile email bmwids organization b2xroles b2d";
export const NONCE  = crypto.randomUUID();
